import { USER_FIELD_IS_TRIAL, useUserInfo } from '../../services/apiService';
import { ActivityType } from '../../util/enums';
import { AudioActivityPopup } from './audioActivityPopup';
import { SubscribePopup } from './SubscribePopup';
import { WrittenActivityPopup } from './writtenActivityPopup';

const ActivityPopup = (props) => {
  const { activity, close, trackProgress } = props;
  const isTrialUser = useUserInfo(USER_FIELD_IS_TRIAL);
  const onCompleted = () => (activity.user_percent_complete = 100);

  if (isTrialUser && !activity.is_trial_content) {
    return <SubscribePopup close={close} />;
  }

  if (activity.activity_type === ActivityType.MEDITATION) {
    return (
      <AudioActivityPopup
        close={close}
        trackProgress={trackProgress}
        onCompleted={onCompleted}
        activity={activity}
      />
    );
  }
  return (
    <WrittenActivityPopup
      close={close}
      trackProgress={trackProgress}
      onCompleted={() => {
        onCompleted();
        close();
      }}
      activity={activity}
    />
  );
};

export { ActivityPopup };
